import { createReducer, on } from '@ngrx/store';
import { loadPartnersCatalogSuccessByKey } from './partners-catalog.actions';

export interface PartnersCatalogState {
  cache: { [key: string]: any };
}

export const initialState: PartnersCatalogState = {
  cache: {},
};

export const partnersCatalogReducer = createReducer(
  initialState,
  on(loadPartnersCatalogSuccessByKey, (state, { key, response }) => ({
    ...state,
    cache: { ...state.cache, [key]: response },
  })),
);
